import {cx} from "@emotion/css";
import {ReactComponent as SvgCalculator} from "assets/svg/calculator.svg";

import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmCalculatorIcon: React.FC<IIconBase> = ({id, size = "lg", color = designColors.black, className}) => {
  return <SvgCalculator id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
